export const taxContexts = [
  { id: 1, name: 'Corporate Tax - Capital Allowances' },
  { id: 2, name: 'Corporate Tax - P&L' },
  { id: 3, name: 'Employment Tax' },
  { id: 4, name: 'VAT' },
  { id: 5, name: 'Corporate Tax - R&D' },
];